export default __webpack_public_path__ + "static/media/1169571.2d5bb2fc.png";